import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { FamilyResponseDto } from 'src/app/backend';
import { SaveNeedDialogComponent } from 'src/app/shared/dialogs/save-need-dialog/save-need-dialog.component';
import { NeedService } from '../../backend/api/need.service';
import { BasePagedComponent } from '../../core/components/base-paged/base-paged.component';
import { DialogService } from '../../core/dialog/dialog.service';
import { AuthService } from '../../core/services/auth.service';
import { ConfirmDialogComponent } from '../../shared/dialogs/confirm-dialog/confirm-dialog.component';
import { UntypedFormControl } from '@angular/forms';

interface NeedRow {
  id: number;
  title: string;
  description: string;
  date: any;
  family: FamilyResponseDto;
  active: boolean;
}

@Component({
  selector: 'app-needs',
  templateUrl: './needs.component.html',
  styleUrls: ['./needs.component.scss'],
})
export class NeedsComponent extends BasePagedComponent implements OnInit {
  data: NeedRow[] = [];
  searchQueryControl = new UntypedFormControl('');
  isLoading = false;

  constructor(
    private dialogService: DialogService,
    private needsService: NeedService,
    authService: AuthService,
    t: TranslateService,
    messageService: NzMessageService
  ) {
    super(authService, t, messageService);
  }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.isLoading = true;

    this.needsService
      .apiNeedGet({
        ...this.tableData,
        filter: JSON.stringify({
          search: this.searchQueryControl.value,
        }),
      })
      .subscribe(
        (res) => {
          this.pageLoaded(res);
          this.isLoading = false;
          this.data =
            res.results?.map((x) => ({
              id: x.id || 0,
              title: x.title || '',
              description: x.description || '',
              date: moment(x.needDate).format('MM/DD/YYYY'),
              family: x.family || {},
              active: x.active || false,
            })) || [];
        },
        (err) => {
          this.isLoading = false;
        }
      );
  }

  searchNeeds() {
    this.loadData();
  }


  new() {
    this.dialogService
      .open(SaveNeedDialogComponent, {
        size: 'md',
        closeOnClickOutside: false,
      })
      .afterClosed.subscribe((res) => {
        if (res?.saved) {
          this.loadData();
        }
      });
  }

  edit(id: number) {
    this.dialogService
      .open(SaveNeedDialogComponent, {
        size: 'md',
        closeOnClickOutside: false,
        data: {
          id,
        },
      })
      .afterClosed.subscribe((res) => {
        if (res?.saved) {
          this.loadData();
        }
      });
  }

  delete(id: number) {
    this.dialogService
      .open(ConfirmDialogComponent, {
        size: 'sm',
      })
      .afterClosed.subscribe((res) => {
        if (res?.confirmed) {
          this.needsService.apiNeedIdDelete({ id }).subscribe((res) => {
            this.loadData();
          });
        }
      });
  }
}
